import { Search, Filter, ChevronDown, Check } from "lucide-react";
import { useState } from "react";

export function FilterBar({
  searchQuery,
  setSearchQuery,
  statusFilter,
  setStatusFilter,
  sortBy,
  setSortBy,
}) {
  const [filterOpen, setFilterOpen] = useState(false);
  const [sortOpen, setSortOpen] = useState(false);

  return (
    <div className="bg-white dark:bg-[#1E1E1E] border border-[#E5E7EB] dark:border-[#2A2A2A] rounded-xl p-4">
      <div className="flex flex-col md:flex-row gap-3">
        {/* Search */}
        <div className="relative flex-1">
          <Search
            size={18}
            className="absolute left-3 top-1/2 transform -translate-y-1/2 text-[#666666] dark:text-[#A0A0A0]"
          />
          <input
            type="text"
            placeholder="Search categories..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="w-full pl-10 pr-4 py-2.5 rounded-lg border border-[#E5E7EB] dark:border-[#2A2A2A] bg-[#F9FAFB] dark:bg-[#262626] text-[#111111] dark:text-white placeholder-[#666666] dark:placeholder-[#A0A0A0] focus:outline-none focus:ring-2 focus:ring-[#62397f] dark:focus:ring-[#7C3AED] transition-all text-sm font-inter"
          />
        </div>

        {/* Status Filter */}
        <div className="relative">
          <button
            onClick={() => {
              setFilterOpen(!filterOpen);
              setSortOpen(false);
            }}
            className="flex items-center gap-2 px-4 py-2.5 border border-[#E5E7EB] dark:border-[#2A2A2A] bg-white dark:bg-[#262626] text-[#111111] dark:text-white rounded-lg font-medium text-sm font-inter transition-all hover:bg-[#F9FAFB] dark:hover:bg-[#1E1E1E] w-full md:w-auto justify-between md:justify-start"
          >
            <Filter size={18} />
            <span>
              Status:{" "}
              {statusFilter === "all"
                ? "All"
                : statusFilter === "active"
                  ? "Active"
                  : "Disabled"}
            </span>
            <ChevronDown size={16} />
          </button>
          {filterOpen && (
            <div className="absolute right-0 mt-2 w-48 bg-white dark:bg-[#1A1A1A] border border-[#E5E7EB] dark:border-[#2A2A2A] rounded-xl shadow-lg overflow-hidden z-20">
              {["all", "active", "disabled"].map((status) => (
                <button
                  key={status}
                  onClick={() => {
                    setStatusFilter(status);
                    setFilterOpen(false);
                  }}
                  className="w-full flex items-center justify-between px-4 py-2.5 text-sm text-[#111111] dark:text-white hover:bg-[#F9FAFB] dark:hover:bg-[#262626] transition-colors font-inter"
                >
                  <span className="capitalize">
                    {status === "all" ? "All" : status}
                  </span>
                  {statusFilter === status && (
                    <Check size={16} className="text-[#62397f]" />
                  )}
                </button>
              ))}
            </div>
          )}
        </div>

        {/* Sort */}
        <div className="relative">
          <button
            onClick={() => {
              setSortOpen(!sortOpen);
              setFilterOpen(false);
            }}
            className="flex items-center gap-2 px-4 py-2.5 border border-[#E5E7EB] dark:border-[#2A2A2A] bg-white dark:bg-[#262626] text-[#111111] dark:text-white rounded-lg font-medium text-sm font-inter transition-all hover:bg-[#F9FAFB] dark:hover:bg-[#1E1E1E] w-full md:w-auto justify-between md:justify-start"
          >
            Sort:{" "}
            {sortBy === "name"
              ? "Name"
              : sortBy === "date"
                ? "Date"
                : "Products"}
            <ChevronDown size={16} />
          </button>
          {sortOpen && (
            <div className="absolute right-0 mt-2 w-48 bg-white dark:bg-[#1A1A1A] border border-[#E5E7EB] dark:border-[#2A2A2A] rounded-xl shadow-lg overflow-hidden z-20">
              {[
                { value: "name", label: "Name" },
                { value: "date", label: "Date Created" },
                { value: "products", label: "Product Count" },
              ].map((option) => (
                <button
                  key={option.value}
                  onClick={() => {
                    setSortBy(option.value);
                    setSortOpen(false);
                  }}
                  className="w-full flex items-center justify-between px-4 py-2.5 text-sm text-[#111111] dark:text-white hover:bg-[#F9FAFB] dark:hover:bg-[#262626] transition-colors font-inter"
                >
                  <span>{option.label}</span>
                  {sortBy === option.value && (
                    <Check size={16} className="text-[#62397f]" />
                  )}
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
